import React from 'react'
import Header1 from '../component/Header1'
import Credits from '../component/Credits'
import Legend from '../component/Legend'
import { makeStyles } from '@material-ui/core/styles'
import Foto2 from '../images/informe3foto2.jpg'
import Foto1 from '../images/informe3foto1.jpg'
import { Helmet } from 'react-helmet'

const useStyles = makeStyles(theme => ({
  text: {
    maxWidth: 800,
    margin: '1em auto',
    fontSize: 16,
    fontFamily: 'Roboto Slab',
    [theme.breakpoints.down('sm')]: {
      paddingLeft:20,
      paddingRight:20
    },
  },
  content: {
    position: 'relative',
    background: '#fff',
    paddingTop: '4em',
    paddingBottom: '4em'
  }
}))

const Informe3 = () => {
  const classes = useStyles()
  const bajada =
    'De las 13 EPS del sur, seis aplican la ley de los Merese para cuidar sus fábricas hídricas. La mayoría dieron algunos pasos, como cobrar un porcentaje a sus usuarios, para conservar y preservar el líquido. ¿Cómo van aplicando la norma estas empresas? Esta es una mirada a todo el sur.'

  return (
    <div>
      {/*<Helmet>
        <meta charSet="utf-8" />
        <title>Fuentes de agua para ciudades del sur en peligro</title>
        <link rel="canonical" href="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua/fuentes-agua-ciudades-sur-peligro" />
        <meta property="og:url" data-react-helmet="true" content="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua/fuentes-agua-ciudades-sur-peligro" />
				<meta name="description" data-react-helmet="true" content="De las 13 EPS del sur, seis aplican la ley de los Merese para cuidar sus fábricas hídricas." />
				<meta property="og:description" data-react-helmet="true" content="De las 13 EPS del sur, seis aplican la ley de los Merese para cuidar sus fábricas hídricas." />
				<meta property="og:title" data-react-helmet="true" content="Fuentes de agua para ciudades del sur en peligro" />
      </Helmet>*/}
       <Helmet
      title="Fuentes de agua para ciudades del sur en peligro"
      meta={[
        { property: "og:title", content: "Fuentes de agua para ciudades del sur en peligro" },
        { property: "og:image", content: Foto1 },
        { property: "description", content: "De las 13 EPS del sur, seis aplican la ley de los Merese para cuidar sus fábricas hídricas." }
        // Any other meta tags go here as objects or you can just add children directly inside this component.
      ]}
    />
      <Header1
        bajada={bajada}
        title={'Fuentes de agua para ciudades del sur en peligro'}
        legend="Foto: Represa Aguada Blanca de Arequipa. "
        image={Foto1}
      />
      <div className={classes.content}>
        <div className={classes.text}>
          <Credits>
            <p>Textos: Elmer Mamani, Melissa Valdivia y Rufino Motta</p>
          </Credits>
          <br></br>
          <p>
            La protección a la laguna Piuray en Cusco es un caso excepcional. La
            Empresa Prestadora de Servicios (EPS) Sedacusco invirtió en cuidar
            esa fuente. A través de la ley de Mecanismos de Retribución por
            Servicios Ecosistémicos (Merese), acumuló un fondo, el cual es
            pagado por los usuarios. Eso le permitió desarrollar infraestructura
            verde para cuidar Piuray. Sin embargo, las otras 12 EPS del sur
            avanzan a paso muy lento.
          </p>
          <p>
            Juan Carlos Córdova estuvo en Piuray. La Superintendencia Nacional
            de Servicios de Saneamiento (Sunass) llevó a un grupo de gerentes,
            para que observara esta siembra y cosecha de agua que promueve
            Sedacusco. “La situación en Arequipa es más compleja”, sostiene
            Córdova, gerente general de Sedapar.
          </p>
          <p>
            Esta EPS es un usuario más entre los que hacen uso de las aguas de
            la cuenca Quilca-Chili; estas también sirven para el riego agrícola
            y el uso minero, energético e industrial.
          </p>
          <p>
            Sedapar capta el agua del río Chili para tratarla y suministrarla a
            la ciudad. El principal reto está en su sistema de represas. El 30%
            de la capacidad de estos embalses se llenó de barro. Eso redujo su
            aforo.
          </p>
          <p>
            Además, este recurso empozado contiene algas y metales. Por ejemplo,
            los diques de Chalhuanca y Pañe tienen algas, y el de Bamputañe
            posee niveles elevados de hierro y manganeso. Los usuarios de
            Arequipa ya probaron el recurso afectado (mal olor y sabor) por
            algas en 2014. El problema lo originó el agua almacenada en la vieja
            represa de El Pañe. “No queremos que se repita este problema”,
            apunta Córdova. Asimismo, el vaso regulador de todo el sistema es
            Aguada Blanca y es otro problema grave. Si sigue acumulando
            sedimentos, en 17 años más perderá el 75% de su volumen útil.
          </p>
          <p>
            Sedapar está rezagada y aún no cobra a los usuarios por los Merese.
            El coordinador regional de la Sunass, Saúl Alire, espera que en 2020
            ya empiecen a recaudar fondos y construir infraestructura verde. Su
            nuevo Plan Maestro Optimizado (PMO), donde se incluye el reajuste
            tarifario para los Merese, es evaluado por Sunass.
          </p>
          <p>
            Por lo pronto, se tienen listas las dos fichas técnicas para mejorar
            la calidad y la cantidad de agua. Se le encargó a Descosur su
            confección. En la primera, intervendrán en la zona regulada de la
            cuenca; es decir, donde están las represas. El objetivo es mejorar
            el recurso que almacena Aguada Blanca ampliando bofedales,
            instalando espejos de agua y microrrepresas, y reforestando con
            tola; esto, en las comunidades de Huayllacucho (San Juan de
            Tarucani) y Tambo Cañahuas (Yanahuara). Así impedirán que se colmate
            más. Una reforestación en los alrededores evitará que, en tiempo de
            lluvias, el ingreso del agua con lodo y piedras caiga en la
            infraestructura. Invertirán S/ 10 920 556.
          </p>
          <p>
            La otra iniciativa sería ejecutada en la cuenca no regulada. Sedapar
            brinda el servicio a una parte de esa población con manantiales.
            Ejecutarán los mismos trabajos, pero en los distritos de San Juan de
            Tarucani, Chiguata y Characato. Añadirán la plantación de queñua en
            las laderas del volcán Pichu Pichu. Todo esto demandaría S/ 5 054
            348. Estas iniciativas las evalúa Sedapar. La pelota está en su
            cancha.
          </p>
          <br></br>
          <h2>Desinterés en Puno</h2>
          <p>
            La decisión política y administrativa es importante para empujar los
            Merese, algo que no se advierte en todas las EPS del Altiplano. Al
            momento, ninguna aplica esta ley que rige desde el 2014. Puno tiene
            cinco empresas. Las únicas que muestran interés, son EMSA Puno
            (Puno) y EMAPA (Yunguyo). El especialista ambiental de la Sunass en
            Puno, Luis Mamani Quispe, sostuvo que les otorgan asistencia técnica
            ante su falta de especialistas. La primera presentará su PMO este
            mes e incluirá los Merese. La otra no define fecha, pero sigue ese
            camino.
          </p>
          <p>
            SEDA Juliaca (San Román), Aguas del Altiplano (Ayaviri) y NOR Puno
            (Azángaro y Huancané) también faltan. La más grande es SEDA Juliaca
            y, por conflictos administrativos, ni siquiera renueva su ya caduco
            PMO.
          </p>
          <p>
            ¿Cuáles son los problemas en Puno? EMSA Puno y EMAPA tienen como
            principal proveedor al Titicaca. El primero se abastece con este del
            80% de su demanda de agua. Sin embargo, el lago tiene problemas de
            calidad por formación algar y la presencia de metales. Sunass y el
            Instituto del Mar del Perú (Imarpe), notaron que la aparición de
            algas sería por la proliferación de criaderos de trucha y los
            vertimientos de aguas residuales.
          </p>
          <p>
            Por ahí apuntaría la intervención con los Merese. Con el fondo
            financiarían estudios para determinar acciones a mediano plazo. En
            SEDA Juliaca, que se abastece del río Coata, hay problemas para
            tratar el líquido con metales pesados.
          </p>

          <br></br>
          <br></br>
        </div>
        <img
          src={Foto2}
          alt="Fuentes de agua para ciudades del sur en peligro"
          style={{ maxWidth: '100%' }}
        />
        <Legend>Represa de Pasto Grande, en Moquegua.</Legend>
        <div className={classes.text}>
          <br></br>
          <h2>Un paso en EPS Moquegua</h2>
          <p>
            En la región de las paltas, operan dos EPS, la de Moquegua e Ilo. La
            primera abastece del líquido potable a 21 000 usuarios del distrito
            de Moquegua y cuatro centros poblados. No llega a todas las
            localidades. La coordinadora de la oficina de enlace del Ministerio
            del Ambiente, María Barrios, informó que distritos como Samegua
            consumen agua a medio tratar.
          </p>
          <p>
            La entidad utiliza el recurso de la represa Pasto Grande y la cuota
            la completa con el río Tumilaca, pero las aguas del embalse cobijan
            metales de procedencia natural y antropogénica. Barrios añade que
            los bofedales, que contribuyen a alimentar la presa, se van
            agotando. “Esto, por efecto del calentamiento global”.
          </p>
          <p>
            La implementación de Merese en la EPS Moquegua empezó. El fondo se
            acumula desde marzo y no supera los S/ 30 000. Para su gerente, Raúl
            Linares, la empresa solo se encargaba de captar el agua, tratarla y
            distribuirla; pero, con los Merese, se añade una función más:
            conservarla. Aún no se decidió qué proyectos se implementarán.
            Linares adelantó que utilizarían el dinero para la recuperación de
            los bofedales y acciones de reforestación.
          </p>
          <p>
            La EPS Ilo también capta de Pasto Grande. Aunque no interviene su
            fuente, la Sunass aprobó el proyecto de actualización del plan
            tarifario. De lo que pagan sus usuarios, el 1% se destina al fondo.
          </p>
          <br></br>
          <h2>Situación grave en Tacna</h2>
          <p>
            La situación es más grave en Tacna. La oferta de agua bordea los 700
            litros por segundo (l/s), pero la demanda sobrepasa los 1100 l/s. Es
            decir, hay un déficit de alrededor de 35%. La EPS Tacna toma el
            recurso de dos cuencas de Uchusuma y Caplina, además de aguas
            superficiales y del subsuelo en la zona andina (provincia
            Candarave). Con ello entrega el servicio a 92 mil usuarios.{' '}
          </p>
          <p>
            Sus fuentes no tienen solo problemas de cantidad, sino de calidad.
            Hay presencia de metales porque viene de territorios mineralizados y
            volcánicos. Pese al proceso de potabilización de la planta Calana,
            cada cierto tiempo los usuarios se quejan de que se entrega agua con
            arsénico. El Ministerio de Vivienda, Construcción y Saneamiento
            levanta una nueva planta en la zona, pero ésta se quedó paralizada
            en un 32% de avance por inconvenientes con la contratista. También
            afrontan restricciones en la dotación. Hay pobladores que cuentan
            solo por 16 horas de líquido elemento en sus casas.{' '}
          </p>
          <p>
            El Gobierno Regional de Tacna tiene planeado solucionar esto con el
            proyecto de Vilavilani 2, pero está paralizado. Buscan traer 500 l/s
            de agua de los ojos ubicados en la provincia de Tarta mediante un
            sistema de bombeo y canalización. El proyecto pretende cubrir el
            déficit existente y brindar una mejor calidad de vida para la
            población.
          </p>
          <p>
            Para el coordinador regional de Sunass Tacna, Elvis Llanos, se debe
            priorizar el cuidado de otras fuentes. La EPS Tacna cobra un
            promedio de S/.0.45 por usuario para el fondo de retribución, pero
            el monto recaudado aún no alcanza como para hacer importantes
            acciones.
          </p>

          <br></br>
          <br></br>
        </div>
      </div>
    </div>
  )
}

export default Informe3
